<!--  -->
<template>
  <div class="app-container">
    <div class="select_box">
      <div>
        <el-input v-model="query.corp_name" class="select_input" placeholder="请输入企业名称" />
        <el-input v-model="query.advertiser_name" class="select_input" placeholder="请输入广告主名称" />
        <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button type="info" icon="el-icon-refresh-right" @click="reast">重置</el-button>
      </div>
      <div>
        <el-button type="success" icon="el-icon-plus" @click="addbind(1)">新增绑定</el-button>
      </div>
    </div>
    <el-table
      v-loading="loadingtable"
      :data="tableData"
      border
      max-height="700"
    >
      <el-table-column
        prop="corp_name"
        label="企业名称"
        width="150"
        align="center"
      />
      <el-table-column
        prop="corp_id"
        label="企业id"
        width="350"
        align="center"
      />
      <el-table-column
        prop="advertiser_name"
        label="广告主名称"
        width="220"
        align="center"
      />
      <el-table-column
        prop="account_id"
        label="广告主id"
        width="100"
        align="center"
      />
      <el-table-column
        prop="created_at_text"
        label="创建时间"
        width="200"
        align="center"
      />
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button type="warning" size="mini" @click="exporte(scope.row)">导出</el-button>
          <el-button type="primary" size="mini" @click="look(scope.row)">查看绑定公众号/员工</el-button>
          <!-- <el-button type="primary" size="mini" @click="lookband(scope.row.id,1)">查看绑定公众号</el-button>
          <el-button type="success" size="mini" @click="lookband(scope.row.id,2)">查看绑定企业员工</el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <pagination-right
      :current-page="query.page"
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
    <!-- 新增行为源弹窗 -->
    <el-dialog
      title="新增绑定"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="35%"
      append-to-body
      :destroy-on-close="true"
    >
      <bandadrtion ref="sur" @updata="updata" />
    </el-dialog>
    <!-- 新增行为源弹窗 -->
    <el-dialog
      title="查看绑定公众号/员工"
      :visible.sync="dialogVisibleacc"
      :close-on-click-modal="false"
      width="50%"
      append-to-body
      :destroy-on-close="true"
      @close="niwr"
    >
      <!-- <div v-if="itenarr.length!=0">
        <el-tag v-for="item,index in itenarr" :key="index" style="margin-right:10px;margin-bottom:10px">{{ item }}</el-tag>
        <el-button v-if="type === 1" type="warning" size="mini" icon="el-icon-plus" @click="chorwer">新增绑定公众号</el-button>
        <el-button v-if="type === 2" type="warning" size="mini" icon="el-icon-plus" @click="chorwe">新增绑定企业员工</el-button>
      </div> -->
      <div>
        <div class="list_add">
          <el-button type="warning" icon="el-icon-plus" @click="adarwer">新增</el-button>
        </div>
        <el-table
          :data="tableDatar"
          border
          style="width: 100%"
        >
          <el-table-column
            prop="account_name"
            label="公众号"
            align="center"
          >
            <template slot-scope="scope">
              <!-- {{ scope.row }} -->
              <el-tag
                v-for="tag in scope.row.account_name.split(',')"
                :key="tag"
                style="margin-right:10px;margin-bottom:10px"
                closable
                @close="closechange(tag)"
              >
                {{ tag }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column
            prop="corp_user_name"
            label="员工"
            align="center"
          />
        </el-table>
        <!-- <pagination-right
          :current-page="parmas.page"
          :total="looktotal"
          @size-change="fetchPageSizelook"
          @current-change="fetchCurrentPagelook"
        /> -->
      </div>
    </el-dialog>
    <el-dialog
      title="导出"
      :visible.sync="exportdialogVisible"
      :close-on-click-modal="false"
      width="20%"
      @close="daewr"
    >
      <el-form label-position="right" label-width="100px" :model="form">
        <el-form-item label="下载文件类型">
          <el-select v-model="form.type" placeholder="请选择" style="width:230px">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="下载文件条件">
          <el-select v-model="form.all_openid" placeholder="请选择" style="width:230px">
            <el-option
              v-for="item in optionsr"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="sumbit">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="选择公众号"
      :visible.sync="dialogVisibleaccr"
      :append-to-body="true"
      :close-on-click-modal="false"
      width="50%"
    >
      <bandaccount ref="bandaccountview" @bandarrview="bandarrview" />
    </el-dialog>
    <el-dialog
      title="绑定员工"
      :visible.sync="dialogVisibler"
      :append-to-body="true"
      :close-on-click-modal="false"
      width="50%"
    >
      <bandstaff ref="bandstaffview" @bandarr="bandarr" />
    </el-dialog>

    <el-dialog
      title="新增"
      :visible.sync="dialoerwlog"
      :close-on-click-modal="false"
      width="30%"
      append-to-body
      :destroy-on-close="true"
    >
      <div>
        <el-form label-position="right" label-width="110px" :model="addform">
          <el-form-item label="企业员工">
            <el-tag v-for="items,index in addform.corp_user" :key="index" style="margin-right:10px" closable @close="handleClose(items.user_id,index)">{{ items.name }} </el-tag>
            <el-button type="warning" size="mini" @click="chorwe">选择企业员工</el-button>
          </el-form-item>
          <el-form-item label="公众号">
            <el-tag v-for="items,index in addform.official_account" :key="index" style="margin-right:10px" closable @close="handleCloseacc(items.app_id,index)">{{ items.account_name }} </el-tag>
            <el-button type="warning" size="mini" @click="chorwer">选择公众号</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="dawer">确定</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import { customgetAdvertilist, customAudiencesexportOpenid, custombindingOfficialAccount, custombindingOfficialAcc } from '@/api/ad.js'
import bandadrtion from './components/bandadrtion.vue'
import downloadFile from '@/utils/mixins/convertToHump.js'
import bandaccount from './components/bandaccount.vue'
import bandstaff from './components/bandstaff.vue'
export default {
  components: { PaginationRight, bandadrtion, bandaccount, bandstaff },
  mixins: [downloadFile],
  data() {
    return {
      query: {
        page: 1,
        page_size: 10,
        corp_name: null,
        advertiser_name: null
      },
      parmasrtotal: null,
      total: null,
      dialogVisible: false,
      tableData: [],
      loadingtable: false,
      itenarr: [],
      dialogVisibleacc: false,
      exportdialogVisible: false,
      form: {
        sort_id: null,
        type: null,
        all_openid: null
      },
      addform: {
        corp_user: [],
        official_account: []
      },
      parmas: {
        page: 1,
        page_size: 10,
        sort_id: null
      },
      looktotal: null,
      options: [
        {
          value: 'txt',
          label: 'txt格式'
        },
        {
          value: 'csv',
          label: 'csv格式'
        }
      ],
      optionsr: [
        {
          value: 0,
          label: '关注公众号并且加了企微人员'
        },
        {
          value: 1,
          label: '全部的关注公众号openid'
        }
      ],
      type: null,
      dialogVisibleaccr: false,
      dialogVisibler: false,
      dialoerwlog: false,
      corp_id: null,
      tableDatar: [],
      iteminfo: {}
    }
  },
  created() {
    this.list()
  },
  mounted() {

  },
  methods: {
    search() {
      this.query.page = 1
      this.list()
    },
    async list() {
      try {
        this.loadingtable = true
        const data = await customgetAdvertilist(this.query)
        this.tableData = data.data.list
        this.total = data.data.total
        this.loadingtable = false
        console.log('列表', data.data)
      } catch {
        this.loadingtable = false
        this.tableData = []
      }
    },
    reast() {
      this.query.page = 1
      this.query.corp_name = null
      this.query.advertiser_name = null
      this.list()
    },
    // 分页
    fetchPageSize(e) {
      this.query.pageSize = e
      this.list()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.list()
    },
    addbind(type) {
      this.dialogVisible = true
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.sur.opens(type)
      }, 100)
    },
    updata() {
      this.dialogVisible = false
      this.$message({
        message: '新增绑定成功',
        type: 'success'
      })
      this.list()
    },
    exporte(item) {
      console.log(item)
      this.exportdialogVisible = true
      this.form.sort_id = item.id
      // this.$confirm('确定要导出吗?', '提示', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   type: 'warning'
      // }).then(() => {
      //   // unbindaccount({
      //   //   app_ids: [this.appId],
      //   //   strategy_no: item.strategyNo
      //   // }).then((res) => {
      //   //   this.$message({
      //   //     type: 'success',
      //   //     message: '导出成功!'
      //   //   })
      //   // window.open(res.data.url, '_blank')
      //   // })
      // }).catch(() => {
      //   // this.$message({
      //   //   type: 'info',
      //   //   message: '已取消删除'
      //   // })
      // })
    },
    async sumbit() {
      if (this.form.type === null) {
        this.$message.error('请选择类型')
        return
      }
      if (this.form.all_openid === null) {
        this.$message.error('请选择下载条件')
        return
      }
      const data = await customAudiencesexportOpenid(this.form)
      this.$message({
        type: 'success',
        message: '导出成功!'
      })
      if (this.form.type === 'txt') {
        this.downloadFile(data.data.url, data.data.file_name)
      } else {
        window.open(data.data.url, '_blank')
      }
      console.log('data', data.data.url)
    },
    daewr() {
      console.log('111')
      this.form.id = null
      this.form.all_openid = null
      this.form.type = null
    },
    async lookband(id, type) {
      console.log('id', id)
      this.dialogVisibleacc = true
      this.type = type
      const data = await customgetAdvertilist({
        sort_id: id
      })
      if (type === 1) {
        console.log('data', data.data.account_name)
        this.itenarr = data.data.account_name.split(',')
      } else {
        this.itenarr = data.data.corp_user_name.split(',')
      }
    },
    chorwer() {
      this.dialogVisibleaccr = true
      this.$nextTick(() => {
        this.$refs.bandaccountview.sendr(this.addform.official_account, this.iteminfo.account_id, this.iteminfo.corp_id)
      })
    },
    bandarrview(arr) {
      this.dialogVisibleaccr = false
      this.addform.official_account = arr
      console.log(arr)
    },
    chorwe() {
      this.dialogVisibler = true
      this.$nextTick(() => {
        this.$refs.bandstaffview.sendr(this.corp_id, this.addform.corp_user, this.iteminfo.account_id)
      })
    },
    async bandarr(arr, sp_strategy_no, arrname) {
      // this.dialogVisibler = false
      this.dialogVisibler = false
      this.addform.corp_user = arr
      console.log(arr)
    },
    look(item) {
      console.log(item)
      this.corp_id = item.corp_id
      this.dialogVisibleacc = true
      this.parmas.sort_id = item.id
      this.iteminfo = item
      this.looklist()
    },
    async looklist() {
      const data = await customgetAdvertilist(this.parmas)
      if (data.data === null) {
        this.tableDatar = []
      } else {
        this.tableDatar = [data.data]
      }
      console.log('data', data)
    },
    fetchPageSizelook(e) {
      this.parmas.pageSize = e
      this.looklist()
    },
    fetchCurrentPagelook(e) {
      this.parmas.page = e
      this.looklist()
    },
    handleClose(id, index) {
      console.log(index)
      this.addform.corp_user.splice(index, 1)
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.bandstaffview.set(id)
      }, 100)
    },
    handleCloseacc(id, index) {
      console.log(index)
      this.addform.official_account.splice(index, 1)
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.bandaccountview.set(id)
      }, 100)
    },
    adarwer() {
      this.dialoerwlog = true
    },
    async dawer() {
      // if (this.addform.corp_user.length === 0) {
      //   this.$message.error('请选择企业人员')
      //   return
      // }
      // if (this.addform.official_account.length === 0) {
      //   this.$message.error('请选择公众号')
      //   return
      // }
      const data = await custombindingOfficialAccount({
        corp_name: this.iteminfo.corp_name,
        corp_id: this.iteminfo.corp_id,
        corp_user: this.addform.corp_user,
        official_account: this.addform.official_account,
        account_id: this.iteminfo.account_id,
        advertiser_name: this.iteminfo.advertiser_name,
        sort_id: this.iteminfo.id
      })
      console.log('data', data)
      this.looklist()
      this.dialoerwlog = false
      this.addform.corp_user = []
      this.addform.official_account = []
      this.$message({
        type: 'success',
        message: '新增成功!'
      })
    },
    niwr() {
      console.log('111')
      this.iteminfo = {}
      this.addform.corp_user = []
      this.addform.official_account = []
    },
    closechange(row) {
      console.log('row', row, this.parmas.sort_id)
      this.$confirm('确定要解绑吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        custombindingOfficialAcc({
          sort_id: this.parmas.sort_id,
          wechat_name: row
        }).then((res) => {
          this.$message({
            type: 'success',
            message: '解绑成功!'
          })
          this.looklist()
        })
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // })
      })
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.select_box{
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  justify-content: space-between;
}
.select_input{
  width: 200px;
  margin-right: 20px;
}
.list_add{
  text-align: right;
  margin-bottom: 10px;
}
</style>
